export const DASHBOARD_SELECTEDCITY = 'DASHBOARD_SELECTEDCITY';